import classnames from 'classnames';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import {
  fetchNotifications,
  markAllNotificationsRead,
  markNotificationRead,
  setPageTitle,
} from 'signoxe/actions';
import { Box, Page } from 'signoxe/components/layout';
import { Button } from 'signoxe/components/widgets';
import { NotificationPropType } from 'signoxe/constants/propTypes';
import { getNotifications } from 'signoxe/selectors';
import ta from 'time-ago';
import './styles.scss';

class NotificationsListPage extends Component {
  static propTypes = {
    notifications: PropTypes.arrayOf(NotificationPropType).isRequired,
    match: PropTypes.object.isRequired,
    setPageTitle: PropTypes.func.isRequired,
    fetchNotifications: PropTypes.func.isRequired,
    markNotificationRead: PropTypes.func.isRequired,
    markAllNotificationsRead: PropTypes.func.isRequired,
  };

  handleMarkAllRead = () =>
    this.props.markAllNotificationsRead()

  handleMarkRead = (notification) =>
    this.props.markNotificationRead(notification)

  componentDidMount() {
    this.props.fetchNotifications();
    this.props.setPageTitle('Notifications');
    this.markCurrentNotificationRead();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.match.params.notificationId !== this.props.match.params.notificationId) {
      this.markCurrentNotificationRead();
    }
  }

  getExpandedRender(notification) {
    const expandedId = this.props.match.params.notificationId;

    if (expandedId == notification.id) {
      return (
        <Box direction="column" className="expanded">
          <Box direction="row" className="meta" justifyContent="space-between">
            <span className="label">{notification.topic}</span>
          </Box>
          <div className="content" dangerouslySetInnerHTML={{__html: notification.content}}/>
        </Box>
      );
    }
  }

  getNotification(notificationId) {
    return this.props.notifications.find((notification) => notification.id == notificationId);
  }

  markCurrentNotificationRead() {
    const notificationId = this.props.match.params.notificationId;

    if (notificationId !== undefined && this.props.notifications.length > 0) {
      const notification = this.getNotification(notificationId);

      if (!notification.is_read) {
        setTimeout(() => {
          this.handleMarkRead(notification);
        }, 2000);
      }
    }
  }

  render() {
    const currNotifId = this.props.match.params.notificationId;

    return (
      <Page>
        <Box direction="row" justifyContent="flex-end">
          <Button onClick={this.handleMarkAllRead}>Mark all read</Button>
        </Box>
        <Box direction="column" className="notifications-list">
          {this.props.notifications.map(notification => (
            <Box direction="column"
                 key={`notif-post-${notification.id}`}
                 className={classnames('notifications-entry', {'unread': !notification.is_read})}>
              <Box direction="row" alignItems="center">
                <img src={notification.icon} alt={notification.topic}/>
                <Link className="tappable-link"
                      to={`/notifications/${currNotifId == notification.id ? '' : notification.id}`}>
                  {notification.title}
                </Link>
                <span className="posted-on">{ta.ago(notification.posted_on)}</span>
              </Box>
              {this.getExpandedRender(notification)}
            </Box>
          ))}
        </Box>
      </Page>
    );
  }
}

export default connect((state) => ({
  notifications: getNotifications(state),
}), {
  fetchNotifications,
  markNotificationRead,
  markAllNotificationsRead,
  setPageTitle,
})(NotificationsListPage);



// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./src/containers/NotificationsListPage/index.js